var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 121,
    viewBox: "0 0 122 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_12784_749)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 56.5,
    r: 56.5,
    transform: "matrix(-1 0 0 1 117.5 0)",
    fill: "url(#paint0_linear_12784_749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9994 80.0202C60.2994 80.0202 59.5995 79.8569 59.0162 79.5302C54.6528 77.1502 46.9994 74.6302 42.1928 74.0002L41.5162 73.9069C38.4595 73.5336 35.9395 70.6635 35.9395 67.5602V39.3735C35.9395 37.5301 36.6628 35.8502 37.9928 34.6369C39.3228 33.4235 41.0494 32.8402 42.8694 33.0035C47.9794 33.4235 55.7261 35.9902 60.1128 38.7202L60.6727 39.0469C60.8361 39.1169 61.1861 39.1402 61.3261 39.0469L61.6994 38.8135C63.2627 37.8335 65.2227 36.8768 67.3694 36.0135C67.9061 35.8035 68.5127 35.8735 69.0028 36.2002C69.4927 36.5268 69.7728 37.0635 69.7728 37.6468V43.9001L71.7095 42.6168C72.2928 42.2202 73.0627 42.2202 73.6461 42.6168L75.5828 43.9001V34.9869C75.5828 34.1469 76.1894 33.4235 77.0061 33.2601C77.6827 33.1435 78.3595 33.0502 78.9661 33.0035C79.0128 33.0035 79.1995 33.0035 79.2461 33.0035C80.9495 32.8635 82.6994 33.4469 84.0061 34.6602C85.3361 35.8736 86.0594 37.5535 86.0594 39.3968V67.5602C86.0594 70.6868 83.5395 73.5336 80.4595 73.9069L79.6895 74.0002C74.8828 74.6302 67.1828 77.1735 62.9128 79.5302C62.3994 79.8569 61.6994 80.0202 60.9994 80.0202ZM42.2861 36.4568C41.5394 36.4568 40.8628 36.7135 40.3261 37.2035C39.7428 37.7402 39.4161 38.5101 39.4161 39.3735V67.5602C39.4161 68.9368 40.6061 70.2668 41.9361 70.4535L42.6361 70.5469C47.8861 71.2469 55.9361 73.8835 60.6028 76.4502C60.8128 76.5435 61.116 76.5669 61.2327 76.5202C65.9227 73.9302 73.9961 71.2703 79.2695 70.5703L80.0627 70.4768C81.3927 70.3135 82.5828 68.9602 82.5828 67.5835V39.4202C82.5828 38.5568 82.2561 37.8102 81.6727 37.2502C81.0894 36.7135 80.2728 36.4568 79.4328 36.5035C79.3628 36.5035 79.1528 36.5035 79.1061 36.5035V47.1669C79.1061 47.8202 78.7561 48.4035 78.1727 48.7068C77.5894 49.0101 76.9128 48.9869 76.3762 48.6135L72.6895 46.1635L69.0028 48.6135C68.4661 48.9635 67.7894 49.0101 67.206 48.7068C66.646 48.4035 66.2728 47.8202 66.2728 47.1669V40.3302C65.2695 40.8202 64.3594 41.3102 63.566 41.7769L63.1928 42.0101C61.9094 42.8035 60.0895 42.8035 58.8528 42.0335L58.2928 41.6836C54.3495 39.2103 47.1627 36.8301 42.5894 36.4568C42.4727 36.4568 42.3794 36.4568 42.2861 36.4568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 78.0601C60.0433 78.0601 59.25 77.2667 59.25 76.3101V41.3101C59.25 40.3534 60.0433 39.5601 61 39.5601C61.9567 39.5601 62.75 40.3534 62.75 41.3101V76.3101C62.75 77.2901 61.9567 78.0601 61 78.0601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3333 48.9166C76.9833 48.9166 76.6567 48.8233 76.3534 48.6133L72.6667 46.1633L68.98 48.6133C68.4433 48.9633 67.7667 49.0099 67.1834 48.7066C66.6234 48.4032 66.25 47.82 66.25 47.1666V37.6466C66.25 36.9233 66.6933 36.2932 67.3466 36.0132C70.5666 34.7299 74.09 33.7266 77.0533 33.2599C77.5667 33.1666 78.08 33.33 78.4766 33.6567C78.8733 33.9834 79.0833 34.4734 79.0833 34.9867V47.1666C79.0833 47.82 78.7333 48.4032 78.1499 48.7066C77.8933 48.8466 77.6133 48.9166 77.3333 48.9166ZM72.6667 42.3133C72.9933 42.3133 73.3433 42.4066 73.6466 42.6166L75.5833 43.8999V37.11C73.7167 37.53 71.6867 38.1366 69.75 38.86V43.8999L71.6867 42.6166C71.99 42.4066 72.34 42.3133 72.6667 42.3133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_12784_749",
    x: 0.5,
    y: 0,
    width: 121,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12784_749"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12784_749",
    result: "effect2_dropShadow_12784_749"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12784_749",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12784_749",
    x1: 56.5,
    y1: 0,
    x2: 56.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseInformation);
export default __webpack_public_path__ + "static/media/courseInformation.ea99fb54972209a0773918679b4b884a.svg";
export { ForwardRef as ReactComponent };